import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import {
  inject, observer,
} from 'mobx-react';
import queryString from 'query-string';
import React from 'react';
import * as Yup from 'yup';
import AlertDialog from '../../../components/Dialog/alertDialog';
import {
  FormField,
} from '../../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import {
  translate,
} from '../../../helperFunctions/translation';
import {
  IResetPasswordStore,
} from '../../../mobx-store/storeInterfaces/resetPasswordInterface';
import classes from '../forgotPassword.module.scss';

interface IProps {
  resetPasswordStore: IResetPasswordStore;
  history: any;
  location: any;
}

interface IState {
  formFields: FormField[];
  open: boolean;
  loading: boolean;
  newPassword: string;
}

@inject('resetPasswordStore')
@observer
class ResetPassword extends React.Component<IProps, IState> {
  resetPasswordSchema: any;

  submitButton: any;

  resetToken: any;

  constructor(props: IProps) {
    super(props);
    console.log(this.props);
    const query = new URLSearchParams(this.props.location.search);
    this.resetToken = query.get('token');
    queryString.parse(this.resetToken);
    console.log(this.resetToken);
    this.initResetPasswordSchema();
    this.initState();
    this.submitButton = this.getSubmitButton();
  }

  initResetPasswordSchema = () => {
    this.resetPasswordSchema = Yup.object().shape({
      password1: Yup.string()
        .min(8, translate('loginScreen.passwordValidationMessage'))
        .max(50, 'Too Long!')
        .required('Required'),
      password2: Yup.string()
        .min(8, translate('loginScreen.passwordValidationMessage'))
        .max(50, 'Too Long!')
        .required(translate('loginScreen.requestConfirmation'))
        .oneOf([Yup.ref('password1')], 'Passwords must match'),
    });
  };

  initState = () => {
    this.state = {
      newPassword: '',
      loading: true,
      open: false,
      formFields: [
        {
          name: 'password1',
          label: 'New Password',
          type: 'Password',
          filedType: 'InputField',
        },
        {
          name: 'password2',
          label: 'Confirm Password',
          type: 'Password',
          filedType: 'InputField',
        },
      ],
    };
  };

  handleSubmit = (values: any): void => {
    this.props.resetPasswordStore.handleResetPassword(values.password1, this.resetToken);
    this.handleClickOpen();
  };

  getSubmitButton = () => ({
    title: 'Send',
    onSubmit: this.handleSubmit,
  });

  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
    this.props.history.replace('/login');
  };

  render() {
    const allowReset = (verified: boolean) => {
      console.log(verified);
      if (verified === true) {
        return (
          <div>
            <div><Typography variant="h5" component="h2">  </Typography></div>
            <GeneralFormComponent
              fields={this.state.formFields}
              formTitle=""
              formSchema={this.resetPasswordSchema}
              submitButton={this.submitButton}
              processing={false}
            />
          </div>
        );
      }
      return (<div><Typography variant="h5" component="h2"> Sorry Your Link has Expired </Typography></div>);
    };
    return (
      <div className={classNames(classes.forgotPasswordPage)}>
        {allowReset(this.props.resetPasswordStore.verified)}
        <div>
          <AlertDialog
            title="Wadi Degla Dashboard"
            content={translate('loginScreen.resetPasswordSuccess', {
            })}
            isOpen={this.state.open}
            buttonText="ok"
            handleClose={this.handleClose}
          />
        </div>
      </div>
    );
  }

  componentWillMount(): void {
    this.props.resetPasswordStore.handleResetValidation(this.resetToken);
  }
}

export default ResetPassword;
